'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = require('./SvgIcon');

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BigQuery = (_temp = _class = function (_SvgIcon) {
  _inherits(BigQuery, _SvgIcon);

  function BigQuery() {
    _classCallCheck(this, BigQuery);

    return _possibleConstructorReturn(this, (BigQuery.__proto__ || Object.getPrototypeOf(BigQuery)).apply(this, arguments));
  }

  _createClass(BigQuery, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement(
            'g',
            { id: 'Google-Big-Query', transform: 'translate(5.000000, 7.000000)' },
            _react2['default'].createElement(
              'g',
              { transform: 'translate(0.000000, 0.048625)' },
              _react2['default'].createElement('path', { d: 'M15.4322222,0.139114943 C14.2890741,0.139114943 13.3744444,0.602643678 12.6887037,1.52970115 L12.6887037,1.52970115 L0.514259259,22.7371264 C0.174444444,23.3116092 0.00296296296,23.886092 0,24.460387 L0,24.460387 L0,24.490613 C0.00296296296,25.0650958 0.174444444,25.6395785 0.514259259,26.2140613 L0.514259259,26.2140613 L12.6887037,47.4216743 C13.3744444,48.3485441 14.2890741,48.8122605 15.4322222,48.8122605 L15.4322222,48.8122605 L39.4375926,48.8122605 C40.5809259,48.8122605 41.4951852,48.3485441 42.1809259,47.4216743 L42.1809259,47.4216743 L54.3553704,26.2140613 C54.6953704,25.6393908 54.8668519,25.064908 54.8696296,24.4904253 L54.8696296,24.4904253 L54.8696296,24.4605747 C54.8668519,23.886092 54.6953704,23.3116092 54.3553704,22.7371264 L54.3553704,22.7371264 L42.1809259,1.52970115 C41.4951852,0.602643678 40.5809259,0.139114943 39.4375926,0.139114943 L39.4375926,0.139114943 L15.4322222,0.139114943 Z' }),
              _react2['default'].createElement('path', {
                fill: '#1976D2',
                transform: 'translate(0.000000, 0.048625)',
                d: 'M15.4322222,0.139114943 C14.2890741,0.139114943 13.3744444,0.602643678 12.6887037,1.52970115 L12.6887037,1.52970115 L0.514259259,22.7371264 C0.174444444,23.3116092 0.00296296296,23.886092 0,24.460387 L0,24.460387 L0,24.490613 C0.00296296296,25.0650958 0.174444444,25.6395785 0.514259259,26.2140613 L0.514259259,26.2140613 L12.6887037,47.4216743 C13.3744444,48.3485441 14.2890741,48.8122605 15.4322222,48.8122605 L15.4322222,48.8122605 L39.4375926,48.8122605 C40.5809259,48.8122605 41.4951852,48.3485441 42.1809259,47.4216743 L42.1809259,47.4216743 L54.3553704,26.2140613 C54.6953704,25.6393908 54.8668519,25.064908 54.8696296,24.4904253 L54.8696296,24.4904253 L54.8696296,24.4605747 C54.8668519,23.886092 54.6953704,23.3116092 54.3553704,22.7371264 L54.3553704,22.7371264 L42.1809259,1.52970115 C41.4951852,0.602643678 40.5809259,0.139114943 39.4375926,0.139114943 L39.4375926,0.139114943 L15.4322222,0.139114943 Z'
              }),
              _react2['default'].createElement(
                'g',
                { id: 'Group-9', transform: 'translate(17.222222, 13.941345)' },
                _react2['default'].createElement(
                  'g',
                  { id: 'Group-6', transform: 'translate(1.296296, 2.440613)' },
                  _react2['default'].createElement('path', {
                    fill: '#545874',
                    fillOpacity: '0.203562063',
                    d: 'M23.662537,31.0883598 L31.8627222,16.8034517 L15.4321667,0.146080077 L4.45809259,0.146080077 L-5.55555556e-05,6.40399962 L2.05753704,15.4432793 L18.8614259,32.478946 L20.9192037,32.478946 C22.0621667,32.478946 22.9766111,32.0152295 23.662537,31.0883598'
                  })
                ),
                _react2['default'].createElement('path', {
                  fill: '#FFFFFF',
                  d: 'M12.7847222,10.930567 L15.1852778,10.930567 L15.1852778,12.1473065 C14.785463,13.2194866 13.7160185,14.302931 12.7847222,14.9288544 L12.7847222,10.930567 Z M9.1837963,7.45381992 L11.2413889,7.45381992 L11.2413889,15.8714943 C10.9087963,15.9370153 10.5652778,15.9719349 10.2125,15.9719349 C9.86009259,15.9719349 9.51657407,15.9370153 9.1837963,15.8714943 L9.1837963,7.45381992 Z M5.58305556,10.0545747 L7.81194444,10.0545747 L7.81194444,15.2694138 C6.9225,14.7341686 6.03231481,13.8621188 5.58305556,12.9053985 L5.58305556,10.0545747 Z M10.2125,18.0577203 C14.3923148,18.0577203 17.7573148,14.7236552 17.7573148,10.5828736 C17.7573148,6.44227969 14.3923148,3.10802682 10.2125,3.10802682 C6.03287037,3.10802682 2.66805556,6.44152874 2.66805556,10.5828736 C2.66805556,14.7244061 6.03287037,18.0577203 10.2125,18.0577203 L10.2125,18.0577203 Z M22.2984259,20.7465249 C22.5408333,20.9922759 22.5408333,21.2378391 22.2984259,21.48359 L21.0856481,22.7130958 C20.8434259,22.958659 20.6010185,22.958659 20.3586111,22.7130958 L16.6071296,18.9094943 C12.5671296,22.0490613 6.79212963,21.742295 3.0912037,17.9903218 C3.08157407,17.9805594 3.07194444,17.9707969 3.06231481,17.9608467 C-0.939351852,13.8878391 -0.926574074,7.29705747 3.0912037,3.2401954 C3.10083333,3.23043295 3.11046296,3.2206705 3.12027778,3.21090805 C7.13787037,-0.846141762 13.6387963,-0.832812261 17.6406481,3.2401954 C21.3423148,6.99930268 21.6439815,12.8400651 18.5473148,16.9423602 L22.2984259,20.7465249 Z'
                })
              )
            )
          )
        );
      }

      return render;
    }()
  }]);

  return BigQuery;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 64 64'
}, _temp);
exports['default'] = BigQuery;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui/SvgIcon/BigQuery.js
// module id = 1372
// module chunks = 32